<div class="container">
  <div class="page-container">
    <div class="page-title">Manage Programs</div>
    <mat-divider class="divider-top"></mat-divider>
    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-programs">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Programs</div>
        <div class="pagination-select table-container">
          <mat-form-field>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          (click)="clearFilters()"
          [className]="
            this.getBaseQueryString() === this.getFullQueryString() ? 'clear-filter disabled-filter' : 'clear-filter'
          ">
          Clear All Filters
        </div>
      </div>
      <div class="right-section">
        <div class="add-new-program">
          <button color="primary" data-cy="newProgram" mat-raised-button routerLink="/admin/manage/program/edit">
            Add a New Program
          </button>
        </div>
      </div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>

    <div class="table-container">
      <table [dataSource]="dataSource" aria-describedby="Program List" mat-table>
        <ng-container matColumnDef="programName">
          <th *matHeaderCellDef mat-header-cell scope="col">
            <div (click)="toggleSingleSort('name')" class="header-with-sort">
              <span>Program Name</span>
              <span [class]="sortBy['name']" id="sort-icon-container">
                <fc-sort-icon [column]="'name'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
            <mat-form-field>
              <input
                #filterName
                (keyup)="applyFilter($event, 'name')"
                [(value)]="filterValues.name"
                matInput
                placeholder="Filter by Name" />
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div (click)="editProgram(row.id)" class="program-link" data-cy="programLink">
              {{ row.name }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="isActive">
          <th *matHeaderCellDef class="medium-column" mat-header-cell scope="col">
            <div>Program Type</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="applyFilter($event, 'is_national', 'eq')"
                [(value)]="filterValues.is_national"
                class="select-filter"
                panelClass="is-national-panel"
                placeholder="Filter">
                <mat-option [value]="">Both</mat-option>
                <mat-option [value]="0">Regional</mat-option>
                <mat-option [value]="1">National</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" class="medium-column" mat-cell>
            {{ row.isNational ? 'National' : 'Regional' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th *matHeaderCellDef class="small-column" mat-header-cell scope="col">
            <div>Status</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="applyFilter($event, 'is_active', 'eq')"
                [(value)]="filterValues.is_active"
                class="select-filter"
                panelClass="is-active-panel"
                placeholder="">
                <mat-option [value]="">All</mat-option>
                <mat-option [value]="0">Inactive</mat-option>
                <mat-option [value]="1">Active</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" class="small-column" mat-cell>
            <ng-container *ngIf="!row.isActive; else isActive">
              <fa-icon [icon]="['far', 'xmark']" class="red size-20" title="Not Active"></fa-icon>
            </ng-container>
            <ng-template #isActive>
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Active"></fa-icon>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="severity">
          <th *matHeaderCellDef class="medium-column" mat-header-cell scope="col">
            <div>Severity Level</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="applyFilter($event, 'restriction_level', 'eq')"
                [(value)]="filterValues.restriction_level"
                class="select-filter"
                panelClass="restriction-level-panel"
                placeholder="Filter">
                <mat-option [value]="">All</mat-option>
                <mat-option [value]="0">Green</mat-option>
                <mat-option [value]="1">Yellow</mat-option>
                <mat-option [value]="2">Red</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" class="medium-column" mat-cell>
            {{ row.restrictionLevel === 0 ? 'Green' : row.restrictionLevel === 1 ? 'Yellow' : 'Red' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="regions">
          <th *matHeaderCellDef class="medium-column" mat-header-cell scope="col">
            <div>Regions</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="getItemByRegionId($event, 'program_region')"
                [(value)]="filterValues.program_region"
                class="select-filter"
                placeholder="Filter">
                <mat-option>Any</mat-option>
                <mat-option *ngFor="let region of regions" [value]="region.id">
                  {{ region.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" class="medium-column" mat-cell>
            <div [innerHTML]="showRegionText(row)"></div>
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
      <fc-spinner [overlay]="true" name="program-spinner" text="Loading Programs"></fc-spinner>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <fc-table-pagination
      [totalPages]="totalPages"
      (goToPage)="goToPage($event)"
      [currentPage]="currentPage"
      [showPages]="showPages"></fc-table-pagination>
  </div>
</div>
